import React, { useState, useEffect, useCallback } from "react";
import Topbar from "./topBar";
import Sidebar from "./sideBar";
import axios from "axios";
import QRCode from 'qrcode.react';
import Cookies from "universal-cookie";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { API as url1 } from "../../config";
import { Link } from "react-router-dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { MFAVERIFY_PATH, UPDATE_MFA } from "../../constants/url";
import { ERR_GETTING, ERR_POSTING } from "../../constants/alertMessage";
import { privateApiCall } from "../../api/privateApi";
import { toast, Bounce } from 'react-toastify';

const cookies = new Cookies();

const MFASettings = () => {
  const [mfasecret, setMfasecret] = useState(cookies.get("MFASecret"));
  const [loginType, setLoginType] = useState(cookies.get("login_type"));
  const [initialValuesMFA, setInitialValuesMFA] = useState({ email: cookies.get("email") });
  const [isEnabled2FA, setIsEnabled2FA] = useState(false);
  const [isDisabled2FA, setIsDisabled2FA] = useState(false);
  const [initial2FA, setinitial2FA] = useState(cookies.get("isEnabled2FA"));

  useEffect(() => {

  }, []);

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();
      const mfaSetting = (initial2FA && !isDisabled2FA && !isEnabled2FA) ? true :
        (!initial2FA && !isDisabled2FA && !isEnabled2FA) ? false :
          isDisabled2FA ? false : (isEnabled2FA ? true : false);

      let data = {
        email: initialValuesMFA.email,
        userType: loginType,
        isEnabled2FA: mfaSetting
      };
      const requestUrl = `${UPDATE_MFA}`
      privateApiCall(requestUrl, "POST", data)
      axios
        .post(`${url1}${UPDATE_MFA}`, data)
        .then((res) => {
          if (res.status === 200) {
            cookies.remove('isEnabled2FA', { path: '/' });
            cookies.set("isEnabled2FA", mfaSetting);
            toast.success('MFA Configuration updated successfully!', {
              transition: Bounce,
              onClose: () => window.location.href = '/organisation/dashboard',
            })
          } else {
            Swal.fire({
              title: `${ERR_GETTING}`,
              icon: "error",
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: "OK",
            });
          }
        })
        .catch((err) => {
          Swal.fire({
            title: `${ERR_GETTING}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        })
        .finally(() => {

        });
    }
  );

  const validationSchemaMFA = Yup.object().shape({
    otp: Yup.string().required("OTP is required"),
  });

  const handleSubmitMFA = (values, { setSubmitting, setFieldError }) => {
    let data = {
      email: initialValuesMFA.email,
      otp: values.otp,
      MFABase32: mfasecret.base32,
      userType: loginType,
    };
    const requestUrl = `${MFAVERIFY_PATH}`
    privateApiCall(requestUrl, "POST", data)
      .then((res) => {
        if (res.status === 200) {
          cookies.remove('isEnabled2FA', { path: '/' });
          cookies.set("isEnabled2FA", isEnabled2FA);
          setSubmitting(false);
          toast.success('MFA Configuration updated successfully!', {
            transition: Bounce,
            onClose: () => window.location.href = '/organisation/dashboard',
          })
        } else {
          setFieldError("otp", "MFA failed. Please try again");
        }
      })
      .catch((err) => {
        setFieldError("otp", "OTP verification failed.");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <div id="wrapper">
      <Topbar backgroundColor="#0baae5" />
      <Sidebar type="profiles" />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <h4 className="page-title float-left"> MFA Configuration</h4>
                  <ol className="breadcrumb float-right">
                    <li className="breadcrumb-item">
                      <Link to="/organisation/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active"> MFA Configuration</li>
                  </ol>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="card-box">
                  <div className="row">
                    <div className="col-12">
                      <div className="p-10">
                        {initial2FA && <div className="mb-4">
                          <span class="badge badge-info"><h5>MFA has been enabled on your account.</h5></span>
                        </div>}
                        {!initial2FA && <div className="mb-4">
                          <span class="badge badge-danger"><h5>MFA has not been enabled for your account.
                            It is recommended to enable MFA for security.</h5></span>
                        </div>}
                        <div className="mb-4">
                          {initial2FA && <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox-2fa"
                              name="isEnabled2FA"
                              checked={isDisabled2FA}
                              onChange={(e) => { setIsDisabled2FA(!isDisabled2FA) }}
                            />
                            <label className="custom-control-label" htmlFor="checkbox-2fa">Disable MFA Configuration</label>
                          </div>}
                          {!initial2FA && <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox-2fa"
                              name="isEnabled2FA"
                              checked={isEnabled2FA}
                              onChange={(e) => { setIsEnabled2FA(!isEnabled2FA) }}
                            />
                            <label className="custom-control-label" htmlFor="checkbox-2fa">Enable MFA Configuration</label>
                          </div>}
                          <div style={{ clear: "both" }}></div>
                        </div>
                        {!initial2FA && isEnabled2FA && !isDisabled2FA &&
                          <Formik
                            initialValues={initialValuesMFA}
                            validationSchema={validationSchemaMFA}
                            onSubmit={handleSubmitMFA}
                            enableReinitialize={true}
                          >
                            {({ isSubmitting }) => (
                              <Form>
                                <div className="mb-4">
                                  <h5> Step 1 : Scan the QR code below with the Google Authenticator app.</h5>
                                  <span><mark>(You can skip Step 1, if "RADTAR BC" already configured in your Authenticator App)</mark></span>
                                </div>
                                <div className="mb-4">
                                  <QRCode value={mfasecret.otpauth_url} />
                                </div>
                                <div className="mb-4">
                                  <h5> Step 2 : Enter the 6 digit code shown against "RADTAR BC" in Authenticator App</h5>
                                  <Field
                                    className="form-control"
                                    style={{ width: "145px" }}
                                    type="otp"
                                    id="otp"
                                    name="otp"
                                    placeholder="Enter 6 Digit Code"
                                  />
                                  <ErrorMessage
                                    name="otp"
                                    component="div"
                                    className="text-danger"
                                  />
                                </div>
                                <div class="mb-4 button-list">
                                  <Link to="/organisation/dashboard">
                                    <button type="button" className="btn btn-danger waves-light waves-effect width-md" >
                                      Cancel
                                    </button>
                                  </Link>
                                  <button type="submit" disabled={isSubmitting} className="btn btn-success waves-light waves-effect width-md" >
                                    Save
                                  </button>
                                </div>
                              </Form>
                            )}
                          </Formik>
                        }
                        {!(!initial2FA && isEnabled2FA) &&
                          <div class="mb-4 button-list">
                            <Link to="/organisation/dashboard">
                              <button type="button" className="btn btn-danger waves-light waves-effect width-md" >
                                Cancel
                              </button>
                            </Link>
                            <button type="button" onClick={handleSubmit} className="btn btn-success waves-light waves-effect width-md" >
                              Save
                            </button>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default MFASettings;
